import React from 'react';
import './PageStyles.css';

const About = () => {
    return (
        <div className="page-container">
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">About Us</h1>
                    <p className="page-hero-subtitle">
                        Learn more about Colorkarma Directory and our mission to connect buyers and suppliers.
                    </p>
                </div>
            </section>
            <section className="value-props-section">
                <div className="value-props-container">
                    <p>Content coming soon...</p>
                </div>
            </section>
        </div>
    );
};

export default About;

